/**
 * Admin HubSpot sidebar configuration
 */
export default {
  pathPrefix: 'admin/hubspot',
  items: [
    {
      label: 'Dashboard',
      href: '/admin/hubspot',
      icon: 'fa-solid fa-chart-line',
      activeUrl: '/admin/hubspot',
      activeExact: true
    },
    {
      label: 'Provisioning',
      href: '/admin/hubspot/provisionings',
      icon: 'fa-solid fa-user-plus',
      activePath: 'admin/hubspot/provisionings'
    },
    {
      label: 'Contacts',
      href: '/admin/hubspot/contacts',
      icon: 'fa-solid fa-user',
      activePath: 'admin/hubspot/contacts'
    },
    {
      label: 'Companies',
      href: '/admin/hubspot/companies',
      icon: 'fa-solid fa-building',
      activePath: 'admin/hubspot/companies'
    },
    {
      label: 'Deals',
      href: '/admin/hubspot/deals',
      icon: 'fa-solid fa-handshake',
      activePath: 'admin/hubspot/deals'
    },
    {
      label: 'Products',
      href: '/admin/hubspot/products',
      icon: 'fa-solid fa-box',
      activePath: 'admin/hubspot/products'
    },
    {
      label: 'Quotes',
      href: '/admin/hubspot/quotes',
      icon: 'fa-solid fa-file-invoice-dollar',
      activePath: 'admin/hubspot/quotes'
    },
    {
      label: 'Sync Logs',
      href: '/admin/hubspot/sync_logs',
      icon: 'fa-solid fa-history',
      activePath: 'admin/hubspot/sync_logs'
    }
  ]
}
